import React, { useState, useRef, useEffect } from "react";
import Header from "../Header";
import { Container, Row, Col } from "react-bootstrap";
import BrandImage from "../../assets/images/brand/brand.png";
import ToggleImage from "../../assets/images/brand/toggleImg.png";
import HoverContent from "../HoverContent";
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { ImCross } from "react-icons/im";

const Navbar = () => {
  const [resorts, setResorts] = useState(false);
  const [hotels, setHotels] = useState(false);
  const [sweets, setSweets] = useState(false);

  const [butwalH, setButwalH] = useState(false);
  const [dhangadiH, setDhangadiH] = useState(false);
  const [bhalubangH, setBhaluangH] = useState(false);
  const [gorusingheH, setGorusingheH] = useState(false);
  const [ghoraiH, setGhoraiH] = useState(false);
  const [jumlaH, setJumlaH] = useState(false);
  const [lamahiH, setLamahiH] = useState(false);
  const [palpaH, setPalpaH] = useState(false);
  const [resungaH, setResungaH] = useState(false);
  const [bhairahawaH, setBhairahawaH] = useState(false);
  const [smallnavbar, setSmallNavbar] = useState(false);
  const [smallShow,setSmallShow]=useState(false)
  const [smallShowResorts,setSmallShowResorts]=useState(false)
  const [smallShowSweets,setSmallShowSweets]=useState(false)
  const [show, setShow] = useState(false);

  const butwalhotel = () => {
    setButwalH(true);
    setBhairahawaH(false);
    setBhaluangH(false);
    setDhangadiH(false);
    setGhoraiH(false);
    setGorusingheH(false);
    setJumlaH(false);
    setLamahiH(false);
    setPalpaH(false);
    setResungaH(false);
  };
  const bhairahawahotel = () => {
    setBhairahawaH(true);
    setButwalH(false);
    setBhaluangH(false);
    setDhangadiH(false);
    setGhoraiH(false);
    setGorusingheH(false);
    setJumlaH(false);
    setLamahiH(false);
    setPalpaH(false);
    setResungaH(false);
  };
  const bhalubanghotel = () => {
    setBhairahawaH(false);
    setButwalH(false);
    setBhaluangH(true);
    setDhangadiH(false);
    setGhoraiH(false);
    setGorusingheH(false);
    setJumlaH(false);
    setLamahiH(false);
    setPalpaH(false);
    setResungaH(false);
  };
  const gorusinghehotel = () => {
    setBhairahawaH(false);
    setButwalH(false);
    setBhaluangH(false);
    setDhangadiH(false);
    setGhoraiH(false);
    setGorusingheH(true);
    setJumlaH(false);
    setLamahiH(false);
    setPalpaH(false);
    setResungaH(false);
  };
  const ghoraihotel = () => {
    setBhairahawaH(false);
    setButwalH(false);
    setBhaluangH(false);
    setDhangadiH(false);
    setGhoraiH(true);
    setGorusingheH(false);
    setJumlaH(false);
    setLamahiH(false);
    setPalpaH(false);
    setResungaH(false);
  };
  const jumlahotel = () => {
    setBhairahawaH(false);
    setButwalH(false);
    setBhaluangH(false);
    setDhangadiH(false);
    setGhoraiH(false);
    setGorusingheH(false);
    setJumlaH(true);
    setLamahiH(false);
    setPalpaH(false);
    setResungaH(false);
  };
  const lamahihotel = () => {
    setBhairahawaH(false);
    setButwalH(false);
    setBhaluangH(false);
    setDhangadiH(false);
    setGhoraiH(false);
    setGorusingheH(false);
    setJumlaH(false);
    setLamahiH(true);
    setPalpaH(false);
    setResungaH(false);
  };
  const palpahotel = () => {
    setBhairahawaH(false);
    setButwalH(false);
    setBhaluangH(false);
    setDhangadiH(false);
    setGhoraiH(false);
    setGorusingheH(false);
    setJumlaH(false);
    setLamahiH(false);
    setPalpaH(true);
    setResungaH(false);
  };
  const resungahotel = () => {
    setBhairahawaH(false);
    setButwalH(false);
    setBhaluangH(false);
    setDhangadiH(false);
    setGhoraiH(false);
    setGorusingheH(false);
    setJumlaH(false);
    setLamahiH(false);
    setPalpaH(false);
    setResungaH(true);
  };
  const dhangadihotel = () => {
    setBhairahawaH(false);
    setButwalH(false);
    setBhaluangH(false);
    setDhangadiH(true);
    setGhoraiH(false);
    setGorusingheH(false);
    setJumlaH(false);
    setLamahiH(false);
    setPalpaH(false);
    setResungaH(false);
  };
  const ref = useRef();
  const closing=()=>{
    setSmallShow(false);
    setSmallNavbar(false);
  }
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        (resorts || hotels || sweets) &&
        ref.current &&
        !ref.current.contains(e.target)
      ) {
        setResorts(false);
        setHotels(false);
        setSweets(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [resorts || hotels || sweets]);
  return (
    <div>
      <section className="navBarContainer largenavbar">
        <Header />

        <Container>
          <nav className="navBar">
            <Link to="/"> 
            <figure className="navBar-brand">
              <img src={BrandImage} alt="" />
            </figure>
            </Link>
            <ul className="navBar-menu">
              <li
                className="navBar-menu__items"
                onClick={() => {
                  setResorts(!resorts);
                }}
              >
                Hotels
              </li>
              <li
                className="navBar-menu__items"
                onClick={() => setHotels(!hotels)}
              >
                Resorts
              </li>
              <li
                className="navBar-menu__items"
                onClick={() => setSweets(!sweets)}
              >
                Sweets
              </li>
              <Link to="/rooms">

              <li className="navBar-menu__items">Rooms</li>
              </Link>
              <Link to="/gallery">
              
              <li className="navBar-menu__items">Gallery</li>
              </Link>
              <Link to="/offer">
              <li className="navBar-menu__items">Offers</li>
              </Link>
              <Link to="/contact">
              <li className="navBar-menu__items">Contact</li>
              </Link>
            </ul>
            {(resorts || hotels || sweets) && (
              <>
                <div className="resortstoggle" ref={ref}>
                  <Row>
                    <Col md={3}>
                      <div className="resortstoggle__leftnav">
                        <ul>
                          <li onMouseEnter={butwalhotel}>Butwal Branch</li>
                          <li onMouseEnter={bhairahawahotel}>
                            Bhairahawa Branch
                          </li>
                          <li onMouseEnter={dhangadihotel}>Dhangadi Branch</li>
                          <li onMouseEnter={bhalubanghotel}>
                            Bhalubang Branch
                          </li>
                          <li onMouseEnter={gorusinghehotel}>
                            Gorusinghe Branch
                          </li>
                          <li onMouseEnter={ghoraihotel}>Ghorai Branch</li>
                          <li onMouseEnter={jumlahotel}>Jumla Branch</li>
                          <li onMouseEnter={lamahihotel}>Lamahi Branch</li>
                          <li onMouseEnter={palpahotel}>Palpa Branch</li>
                          <li onMouseEnter={resungahotel}>Resunga Branch</li>
                        </ul>
                      </div>
                    </Col>
                    <Col md={9}>
                      {butwalH && (
                        <HoverContent
                          image={ToggleImage}
                          paragraph="It is our pleasure to introduce that, The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel. The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel."
                          setResorts={setResorts}
                          setSweets={setSweets}
                          setHotels={setHotels}
                        />
                      )}
                      {bhairahawaH && (
                        <HoverContent
                          image={ToggleImage}
                          paragraph="It is our pleasure to introduce that, The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel. The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel."
                          setResorts={setResorts}
                          setSweets={setSweets}
                          setHotels={setHotels}
                        />
                      )}
                      {dhangadiH && (
                        <HoverContent
                          image={ToggleImage}
                          paragraph="It is our pleasure to introduce that, The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel. "
                          setResorts={setResorts}
                          setSweets={setSweets}
                          setHotels={setHotels}
                        />
                      )}
                      {bhalubangH && (
                        <HoverContent
                          image={ToggleImage}
                          paragraph=" The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel."
                          setResorts={setResorts}
                          setSweets={setSweets}
                          setHotels={setHotels}
                        />
                      )}
                      {gorusingheH && (
                        <HoverContent
                          image={ToggleImage}
                          paragraph="It is our pleasure to introduce that, The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel. The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel."
                          setResorts={setResorts}
                          setSweets={setSweets}
                          setHotels={setHotels}
                        />
                      )}
                      {ghoraiH && (
                        <HoverContent
                          image={ToggleImage}
                          paragraph="It is our pleasure to introduce that."
                          setResorts={setResorts}
                          setSweets={setSweets}
                          setHotels={setHotels}
                        />
                      )}
                      {jumlaH && (
                        <HoverContent
                          image={ToggleImage}
                          paragraph="It is our pleasure to introduce that, The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel. The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel."
                          setResorts={setResorts}
                          setSweets={setSweets}
                          setHotels={setHotels}
                        />
                      )}
                      {lamahiH && (
                        <HoverContent
                          image={ToggleImage}
                          paragraph="It is our pleasure to introduce that, The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel. The Hotel Pauwa is a homely environment with "
                          setResorts={setResorts}
                          setSweets={setSweets}
                          setHotels={setHotels}
                        />
                      )}
                      {palpaH && (
                        <HoverContent
                          image={ToggleImage}
                          paragraph="It is our pleasure to introduce that, The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel. The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel."
                          setResorts={setResorts}
                          setSweets={setSweets}
                          setHotels={setHotels}
                        />
                      )}
                      {resungaH && (
                        <HoverContent
                          image={ToggleImage}
                          paragraph="It is our pleasure to introduce that, The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel. The Hotel Pauwa is a homely environment with typical Nepalese traditional cultural hotel."
                          setResorts={setResorts}
                          setSweets={setSweets}
                          setHotels={setHotels}
                        />
                      )}
                    </Col>
                  </Row>
                </div>
              </>
            )}
            <button className="bton bton--lg bton--primary">Book Now</button>
          </nav>
        </Container>
      </section>

      <Container>
        <div className="smallnavbar">
          <div className="smallnavbar__image">
            <Link to="/">
              <img src={BrandImage} alt="" />
            </Link>
          </div>
          <div>
            <GiHamburgerMenu className="smallnavbar__openicon" onClick={() => setSmallNavbar(!smallnavbar)} />
          
            {smallnavbar && (
              <div className="smallnavbar__display">

                <Link to="/">
                  <img src={BrandImage} alt="" />
                </Link>
                <ImCross onClick={() => setSmallNavbar(false)} className="smallnavbar__display--crossicon"/>

                <ul className="smallnavbar__display--mainul">
                  <li>
                    <Link to="" onClick={() => setSmallShow(!smallShow)}>
                      Hotels
                    </Link>
                    {show ? (
                      <BiChevronUp
                        onClick={() => setSmallShow(!smallShow)}
                        style={{ fontSize: "24px", marginLeft: "10px",color:"#A67D03" }}
                      />
                    ) : (
                      <BiChevronDown
                        onClick={() => setSmallShow(!smallShow)}
                        style={{ fontSize: "24px", marginLeft: "10px",color:"#A67D03" }}
                      />
                    )}
                    {smallShow && (
                      <ul className="smallnavbar__display--mainul-subul">
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Butwal Branch</Link>
                        </li>
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Bhairahawa Branch</Link>
                        </li>
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Dhangadi Branch</Link>
                        </li>
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Resunga Branch</Link>
                        </li>
                       
                      </ul>
                    )}
                  </li>
                  <li>
                    <Link to="" onClick={() => setSmallShowResorts(!smallShowResorts)}>
                      Resorts
                    </Link>
                    {smallShowResorts ? (
                      <BiChevronUp
                        onClick={() => setSmallShowResorts(!smallShowResorts)}
                        style={{ fontSize: "24px", marginLeft: "10px",color:"#A67D03" }}
                      />
                    ) : (
                      <BiChevronDown
                        onClick={() => setSmallShowResorts(!smallShowResorts)}
                        style={{ fontSize: "24px", marginLeft: "10px",color:"#A67D03" }}
                      />
                    )}
                    {smallShowResorts && (
                      <ul className="smallnavbar__display--mainul-subul">
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Butwal Branch</Link>
                        </li>
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Bhairahawa Branch</Link>
                        </li>
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Dhangadi Branch</Link>
                        </li>
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Resunga Branch</Link>
                        </li>
                       
                      </ul>
                    )}
                  </li>
                  <li>
                    <Link to="" onClick={() => setSmallShowSweets(!smallShowSweets)}>
                      Sweets
                    </Link>
                    {setSmallShowSweets ? (
                      <BiChevronDown
                        onClick={() => setSmallShowSweets(!smallShowSweets)}
                        style={{ fontSize: "24px", marginLeft: "10px",color:"#A67D03" }}
                      />
                    ) : (
                      <BiChevronUp
                        onClick={() => setSmallShowSweets(!smallShowSweets)}
                        style={{ fontSize: "24px", marginLeft: "10px",color:"#A67D03" }}
                      />
                    )}
                    {smallShowSweets && (
                      <ul className="smallnavbar__display--mainul-subul">
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Butwal Branch</Link>
                        </li>
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Bhairahawa Branch</Link>
                        </li>
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Dhangadi Branch</Link>
                        </li>
                        <li>
                          <Link to="/branch" 
                          onClick={closing}>Resunga Branch</Link>
                        </li>
                       
                      </ul>
                    )}
                  </li>
                  <li>
                    <Link to="/rooms" onClick={() => setSmallNavbar(false)}>Rooms</Link>
                  </li>
                  <li>
                    <Link to="/gallery" onClick={() => setSmallNavbar(false)}>Gallery</Link>
                  </li>
                  <li>
                    <Link to="/offer" onClick={() => setSmallNavbar(false)}>Offers</Link>
                  </li>
                  <li>
                    <Link to="/contact" onClick={() => setSmallNavbar(false)}>Contact</Link>
                  </li>
                
                </ul>
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
    
  );
};

export default Navbar;
